const ADMIN = "admin";
const SUBSCRIBER = "subscriber";
const EDITOR = "editor";

export { ADMIN, SUBSCRIBER, EDITOR };
